<template>
	<div class="ability-profile-page">
		<!-- 学生艺术综合素养能力画像 -->
		<div class="ap-box" ref="apBox">
			<div class="ap-header">
				<div class="ap-header-icon"></div>
				<div class="ap-header-title">学生艺术综合素养能力画像</div>
			</div>
            <template v-if="abilityData.scores&&abilityData.scores.length>0">
				<div class="ap-user">
					<div class="ap-user-left">
						<img v-if="abilityData.babyImage" :src="abilityData.babyImage" class="ap-avatar" />
						<div v-else class="ap-avatar ap-avatar-default"></div>
						<div class="ap-name">{{ abilityData.babyName || '学生' }}</div>
					</div>
					<div class="ap-save" @click="saveAbilityImage">
						<img src="@/assets/nenglihuaxiagn/icon_xiazai.png" class="ap-save-icon" alt="" />
						<span>保存图片</span>
					</div>
				</div>
				<div class="ap-content">
					<div class="ap-photo">
						<img v-if="abilityData.babyImage" :src="abilityData.babyImage" class="ap-photo-img" alt="" />
						<img v-else src="../../assets/nenglihuaxiagn/avatarPlaceholder.png" class="ap-photo-img" alt="" @click="gettip"/>
					</div>
					<div class="ap-chart">
						<div class="ap-chart-box" ref="radarChart"></div>
					</div>
				</div>
				<div class="ap-info">
					<div class="ap-info-row">
						<img src="@/assets/nenglihuaxiagn/zuopin.png" class="ap-info-icon" alt="" />
						<div class="ap-info-label">作品名称:</div>
						<div class="ap-info-value">{{ abilityData.workName || '-' }}</div>
					</div>
					<div class="ap-info-row">
						<img src="@/assets/nenglihuaxiagn/icon_fangxiang.png" class="ap-info-icon" alt="" />
						<div class="ap-info-label">推荐方向:</div>
						<div class="ap-info-value">{{ recommendText || '-' }}</div>
					</div>
				</div>

				<div class="ap-comment" v-if="growthList && growthList.length">
					<div class="ap-comment-title">专家评语:</div>
					<div class="ap-comment-text">{{ growthList[0].comment }}</div>
				</div>
			</template>
			<div v-else class="gr-empty">暂无能力画像</div>
		</div>

		<!-- 成长记录 -->
		<div class="gr-box">
			<div class="gr-header">
				<img src="@/assets/nenglihuaxiagn/icon_jilu.png" class="gr-header-icon" alt="" />
				<div class="gr-header-title">成长记录</div>
			</div>

			<div class="gr-timeline" v-if="growthList && growthList.length">
				<div
					v-for="(g, idx) in growthList"
					:key="g.activityId + '_' + idx"
					class="gr-item"
				>
					<div class="gr-time">
						<div class="gr-dot"></div>
						<div class="gr-time-text">{{ formatTime(g) }}</div>
					</div>
					<div class="gr-card">
						<div class="gr-card-title">{{ g.activityName || '活动记录' }}</div>
						<div class="gr-scores" v-if="g.scores && g.scores.length">
							<div
								v-for="(s, sIdx) in g.scores"
								:key="'s' + sIdx"
								class="gr-score-item"
							>
								<span class="gr-score-name">{{ s.optionName }}</span>
								<span class="gr-score-val">: {{ s.score }}</span>
							</div>
						</div>
						<div class="gr-row">
							<span class="gr-row-label">推荐方向:</span>
							<span class="gr-row-value">{{g.recommendCareerPath || '无'}}</span>
						</div>
						<div class="gr-row">
							<span class="gr-row-label">专家评语:</span>
							<span class="gr-row-value">{{ g.comment || '无' }}</span>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="gr-empty">暂无成长记录</div>
		</div>
	</div>
</template>

<script>
import * as echarts from "echarts";
import { AbilityProfile, GrowthLog } from "@/utils/api/user";

export default {
	data() {
		return {
			abilityData: {},
			growthList: [],
			radarChartInstance: null
		};
	},
	computed: {
		recommendText() {
			const arr = this.abilityData.recommendCareerPath;
			if (!arr) return "";
			if (Array.isArray(arr)) return arr.filter(Boolean).join("、");
			return String(arr);
		}
	},
	mounted() {
		this.getAbilityProfile();
		this.getGrowthLog();
		window.addEventListener("resize", this.handleRadarResize);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.handleRadarResize);
		if (this.radarChartInstance) {
			this.radarChartInstance.dispose();
			this.radarChartInstance = null;
		}
	},
	methods: {
		gettip(){
			this.$Dialog.confirm({
				title: "温馨提示",
				message: "请在学生管理中上传对应学生的头像",
				allowHTML: true,
				confirmButtonText: "去上传",
				confirmButtonColor: "#31D076",
				cancelButtonText: "取消",
				cancelButtonColor: "#999999"
			}).then(() => {
				this.$router.push("/player/mybaby");
			}).catch(() => {
				// 取消，不做处理
			});
		},
		// 能力画像接口
		getAbilityProfile() {
			AbilityProfile().then(res => {
                console.log("能力画像AbilityProfile res", res);
				if (res.success) {
					this.abilityData = res.data;
					this.$nextTick(() => {
						this.initRadarChart();
					});
				}
			}).catch(err => {
				console.error("AbilityProfile error", err);
			});
		},
		// 成长记录接口
		getGrowthLog() {
			GrowthLog().then(res => {
                console.log("成长记录AbilityProfile res", res);
				if (res.success) {
                    let data = res.data || [];
                    data.map(k=>{
                        k.recommendCareerPath = k.recommendCareerPath.join("、");
                        return k
                    })
					this.growthList = (res.data || []).slice().reverse();
				}
			}).catch(err => {
				console.error("GrowthLog error", err);
			});
		},
		// 初始化 ECharts 雷达图
		initRadarChart() {
			const el = this.$refs.radarChart;
			if (!el) return;
			if (!this.radarChartInstance) {
				this.radarChartInstance = echarts.init(el);
			}
			this.radarChartInstance.setOption(this.getRadarOption(), true);
		},
		getRadarOption() {
			const scores = this.abilityData.scores || [];
			const indicators = scores.map(s => ({
				name: s.optionName || "",
				max: 10
			}));
			const values = scores.map(s => Number(s.score) || 0);
			return {
				radar: {
					indicator: indicators,
					radius: "58%",
					center: ["50%", "50%"],
					splitNumber: 5,
					axisName: {
						color: "#666666",
						fontSize: 12,
						lineHeight: 16,
						padding: [2, 2],
						formatter: name => {
							// 顶部(第0个)与底部(中间)维度名单行显示，其余超 2 字换行
							const idx = indicators.findIndex(ind => ind.name === name);
							const topBottom =
								idx === 0 || idx === Math.floor(indicators.length / 2);
							if (topBottom) return name;
							if (name && name.length > 2) {
								const mid = Math.ceil(name.length / 2);
								return name.slice(0, mid) + "\n" + name.slice(mid);
							}
							return name;
						}
					},
					splitArea: {
						areaStyle: {
							color: ["rgba(166,229,194,0.18)", "rgba(255,255,255,0)"]
						}
					},
					splitLine: {
						lineStyle: { color: "#A6E5C2" }
					},
					axisLine: {
						lineStyle: { color: "#A6E5C2" }
					}
				},
				series: [
					{
						type: "radar",
						data: [
							{
								value: values,
								name: "能力画像",
								areaStyle: { color: "rgba(52,199,123,0.35)" },
								lineStyle: { color: "#34C77B", width: 2 },
								itemStyle: { color: "#34C77B" },
								label: {
									show: true,
									color: "#34C77B",
									fontSize: 13,
									fontWeight: "bold",
									formatter: p => p.value
								}
							}
						]
					}
				]
			};
		},
		// 窗口尺寸变化时重绘
		handleRadarResize() {
			if (this.radarChartInstance) {
				this.radarChartInstance.resize();
			}
		},
		// 保存能力画像为图片
		saveAbilityImage() {
			try {
				if (!this.radarChartInstance) {
					return;
				}
				const url = this.radarChartInstance.getDataURL({
					type: "png",
					pixelRatio: 2,
					backgroundColor: "#ffffff"
				});
				const a = document.createElement("a");
				a.href = url;
				a.download = "能力画像.png";
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			} catch (e) {
				console.error(e);
			}
		},
		formatTime() {
			// 接口未提供时间字段，这里使用当前时间作为占位
			const d = new Date();
			const pad = n => (n < 10 ? "0" + n : "" + n);
			return (
				d.getFullYear() +
				"-" +
				pad(d.getMonth() + 1) +
				"-" +
				pad(d.getDate()) +
				" " +
				pad(d.getHours()) +
				":" +
				pad(d.getMinutes())
			);
		}
	}
};
</script>

<style lang="scss" scoped>
.ability-profile-page {
	padding: 12px;
	background: #F4F6F5;
	min-height: 100vh;
}

/* 能力画像卡片 */
.ap-box {
	background: #FFFFFF;
	border-radius: 10px;
	padding: 15px;
	margin-bottom: 14px;

	.ap-header {
		display: flex;
		align-items: center;
		margin-bottom: 14px;

		.ap-header-icon {
			width: 22px;
			height: 22px;
			border-radius: 50%;
			background: #BFE5FF;
			position: relative;
			margin-right: 6px;
			flex-shrink: 0;

			&::before {
				content: "";
				width: 8px;
				height: 8px;
				border-radius: 50%;
				background: #4FB4F0;
				position: absolute;
				top: 4px;
				left: 4px;
			}

			&::after {
				content: "";
				position: absolute;
				bottom: 4px;
				right: 4px;
				width: 0;
				height: 0;
				border-left: 5px solid transparent;
				border-right: 5px solid transparent;
				border-bottom: 8px solid #4FB4F0;
				transform: rotate(35deg);
			}
		}

		.ap-header-title {
			font-size: 17px;
			font-weight: 600;
			color: #222;
		}
	}

	.ap-user {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 12px;

		.ap-user-left {
			display: flex;
			align-items: center;
		}

		.ap-avatar {
			width: 32px;
			height: 32px;
			border-radius: 50%;
			object-fit: cover;
			background: #F0F0F0;
			margin-right: 8px;
		}

		.ap-avatar-default {
			background: #FFE0CC;
		}

		.ap-name {
			font-size: 15px;
			color: #333;
			font-weight: 500;
		}

		.ap-save {
			display: flex;
			align-items: center;
			background: linear-gradient(90deg, #4DD68A, #34C77B);
			color: #fff;
			font-size: 13px;
			padding: 6px 14px;
			border-radius: 22px;
			cursor: pointer;
			box-shadow: 0 2px 6px rgba(52, 199, 123, 0.25);

			.ap-save-icon {
				width: 14px;
				height: 14px;
				margin-right: 4px;
				filter: brightness(0) invert(1);
			}
		}
	}

	.ap-content {
		display: flex;
		gap: 4px;
		margin-bottom: 14px;
		align-items: center;
	}

	.ap-photo {
		flex-shrink: 0;
		max-width: 130px;
		display: flex;
		justify-content: center;

		.ap-photo-img {
			width: 110px;
			height: 110px;
			aspect-ratio: 1 / 1.1;
			border-radius: 8px;
			object-fit: cover;
			background: #F0F0F0;
			display: block;
		}

		.ap-photo-default {
			background: linear-gradient(135deg, #FFE0CC, #FFCFB8);
		}
	}

	.ap-chart {
		flex: 1;
		min-width: 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.ap-chart-box {
		width: 100%;
		height: 200px;
	}

	.ap-info {
		border-top: 1px solid #F0F0F0;
		padding-top: 12px;
		margin-bottom: 12px;
	}

	.ap-info-row {
		display: flex;
		align-items: center;
		font-size: 14px;
		line-height: 1.9;

		.ap-info-icon {
			width: 12px;
			height: 14px;
			margin-right: 6px;
			flex-shrink: 0;
		}

		.ap-info-label {
			color: #888;
			margin-right: 6px;
			flex-shrink: 0;
		}

		.ap-info-value {
            text-align: left;
			color: #333;
			flex: 1;
			word-break: break-all;
		}
	}

	.ap-comment {
		background: #E8F8EE;
		border-radius: 8px;
		padding: 12px;
	}

	.ap-comment-title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 15px;
        color: #31D076;
        text-align: left;
		margin-bottom: 6px;
	}

	.ap-comment-text {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #222222;
        line-height: 21px;
        text-align: left;
		white-space: pre-wrap;
	}
}

/* 成长记录卡片 */
.gr-box {
	background: #FFFFFF;
	border-radius: 10px;
	padding: 15px;

	.gr-header {
		display: flex;
		align-items: center;
		margin-bottom: 16px;

		.gr-header-icon {
			width: 16px;
			height: 18px;
			margin-right: 7px;
			object-fit: contain;
		}

		.gr-header-title {
            font-family: PingFang SC, PingFang SC;
            font-weight: bold;
            font-size: 17px;
            color: #222222;
            text-align: left;
		}
	}

	.gr-timeline {
		position: relative;
		padding-left: 16px;
		border-left: 2px solid #E8F8EE;
	}

	.gr-item {
		position: relative;
		padding-bottom: 16px;

		&:last-child {
			padding-bottom: 0;
		}
	}

	.gr-time {
		display: flex;
		align-items: center;
		margin-bottom: 8px;

		.gr-dot {
			position: absolute;
			left: -23px;
			top: 0;
			width: 12px;
			height: 12px;
			border-radius: 50%;
			background: #34C77B;
			border: 2px solid #FFFFFF;
			box-shadow: 0 0 0 2px #34C77B;
		}

		.gr-time-text {
			color: #999;
			font-size: 12px;
		}
	}

	.gr-card {
		background: #FAFBFC;
		border-radius: 8px;
		padding: 12px;
	}

	.gr-card-title {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 14px;
        color: #222222;
        text-align: left;
		margin-bottom: 10px;
	}

	.gr-scores {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		row-gap: 8px;
		column-gap: 16px;
		margin-bottom: 10px;
	}

	.gr-changes {
		display: flex;
		flex-wrap: wrap;
		gap: 8px 16px;
		margin-bottom: 8px;
	}

	.gr-score-item,
	.gr-change-item {
		font-size: 14px;
		color: #555;
		display: flex;
		align-items: baseline;
	}

	/* 评分项名称固定为 4 个字宽，保证两列对齐 */
	.gr-score-name {
		display: inline-block;
		width: 4em;
		color: #666;
		flex-shrink: 0;
	}

	.gr-score-val {
		color: #333;
		font-weight: 500;
	}

	.gr-change-name {
		color: #666;
	}

	.gr-change-val {
		color: #2BB673;
		font-weight: 600;
	}

	.gr-row {
        text-align: left;
		font-size: 13px;
		line-height: 1.7;
		color: #555;

		.gr-row-label {
			color: #666;
			margin-right: 4px;
		}

		.gr-row-value {
			color: #333;
		}
	}
}
.gr-empty {
	text-align: center;
	color: #999;
	font-size: 14px;
	padding: 30px 0;
}
</style>
